<template>
  <div
    class="h-full"
    data-testid="content-creator-page"
  >
    <v-card
      :border="$vuetify.display.smAndUp"
      :rounded="$vuetify.display.smAndUp ? 'md' : '0'"
      class="px-2 pt-2 px-md-4"
    >
      <div class="d-flex justify-space-between">
        <v-tabs
          v-model="section"
          height="40"
          :show-arrows="isMobile"
        >
          <v-tab
            value="creator"
            replace
            data-testid="content-creator-tab-creator"
          >
            <span v-if="isMobile">{{ $t('content-creator.tabs.creator-mobile') }}</span>
            <span v-else>{{ $t('content-creator.tabs.creator') }}</span>
          </v-tab>
          <v-tab
            v-if="!isMasterView && isEnabledMarketingAgent"
            value="marketing-agent"
            replace
            data-testid="content-creator-tab-marketing-agent"
          >
            <span v-if="isMobile">{{ $t('content-creator.tabs.marketing-agent-mobile') }}</span>
            <span v-else>{{ $t('content-creator.tabs.marketing-agent') }}</span>
          </v-tab>
          <v-tab
            replace
            value="scheduled-posts"
          >
            <span v-if="isMobile">{{ $t('content-creator.tabs.scheduled-posts-mobile') }}</span>
            <span v-else>{{ $t('content-creator.tabs.scheduled-posts') }}</span>
            <v-badge
              v-if="savedScheduledContentCounter > 0"
              color="red"
              :content="savedScheduledContentCounter"
              offset-x="-12"
              offset-y="-12"
            />
          </v-tab>
          <v-tab
            value="history"
            replace
          >
            {{ $t('content-creator.tabs.saved-content') }}
            <v-badge
              style="margin-top: -25px; padding-left: 13px"
              v-if="savedContentCounter > 0"
              color="red"
              :content="savedContentCounter"
              offset-x="0"
            />
          </v-tab>
        </v-tabs>
        <Feature :feature-slug="featureNames.AI_SETTINGS">
          <CreatorAiSettings />
        </Feature>
      </div>
      <v-divider />
      <v-window
        v-model="section"
        class="pt-4"
      >
        <v-window-item
          value="creator"
          disabled
        >
          <Creator
            v-if="section === 'creator'"
            :key="section"
            :active-tab="section"
            @contentSaved="savedContentCounter++"
            @savedScheduledContent="savedScheduledContentCounter++"
          />
        </v-window-item>
        <v-window-item
          v-if="!isMasterView && isEnabledMarketingAgent"
          value="marketing-agent"
          disabled
        >
          <MarketingAgent
            v-if="section === 'marketing-agent'"
            embedded
          />
        </v-window-item>
        <v-window-item
          value="scheduled-posts"
          disabled
        >
          <SavedContentTimeline
            :key="section"
            :content-type="ContentType.SCHEDULED_CONTENT"
            :update-saved-contents="savedScheduledContentCounter"
          />
        </v-window-item>
        <v-window-item
          value="history"
          disabled
        >
          <SavedContentTimeline
            :key="section"
            :content-type="ContentType.SAVED_CONTENT"
            :update-saved-contents="savedContentCounter"
          />
        </v-window-item>
      </v-window>
    </v-card>
  </div>
</template>
<script>
import featureNames from '@/lib/featureNames'
import feature from '@/mixins/feature'
import { ContentType } from '@/modules/contentCreator/creator/enums/ContentType'
import MarketingAgent from '@/modules/marketingAgent/index.vue'
import { Feature } from '@/plugins/feature-config'

import Creator from './creator'
import KindType from './creator/enums/KindType'
import SavedContentTimeline from './creator/SavedContentTimeline.vue'
import CreatorAiSettings from './creatorAiSettings'
export default {
  name: 'ContentCreator',
  components: {
    Feature,
    MarketingAgent,
    SavedContentTimeline,
    Creator,
    CreatorAiSettings,
  },
  mixins: [feature],
  data() {
    return {
      kind: KindType.facebookPost,
      section: '',
      savedContentCounter: 0,
      savedScheduledContentCounter: 0,
      contentType: ContentType.SAVED_CONTENT,
    }
  },
  computed: {
    isMasterView() {
      return this.$route.path.startsWith('/master')
    },
    isEnabledMarketingAgent() {
      return this.$features.feature(featureNames.MARKETING_AGENT)?.isActive
    },
    validSections() {
      return [
        'creator',
        ...(!this.isMasterView && this.isEnabledMarketingAgent ? ['marketing-agent'] : []),
        'scheduled-posts',
        'history',
      ]
    },
    isMobile() {
      return this.$vuetify.display.smAndDown
    },
    ContentType() {
      return ContentType
    },
  },
  watch: {
    '$route.query.section': {
      handler(section) {
        const view = this.validSections.includes(section) ? section : 'creator'
        if (this.section !== view) this.section = view

        if (!this.validSections.includes(section)) {
          this.$router.replace({
            query: { ...this.$route.query, section: 'creator' },
          })
        }

        if (view === 'scheduled-posts') this.savedScheduledContentCounter = 0
        if (view === 'history') this.savedContentCounter = 0
      },
      immediate: true,
    },
    section: {
      handler(value) {
        if (!value || this.$route.query.section === value) return

        this.$router.push({
          query: { ...this.$route.query, section: value },
        })
      },
    },
  },
}
</script>

<style scoped>
:deep(.v-slide-group__next),
:deep(.v-slide-group__prev) {
  min-width: 35px;
}
</style>
